import React, { useState } from 'react'
import { Modal, message } from 'antd';

const TypeOfMoving = ({ UpdateText, GetData }) => {
    const [HeadingUpdate, setHeadingUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
    const [TextId, setTextId] = useState('')

    const ShowTextModal = (id) => {
        setTextModalVisible(true);
        setTextId(id)
    };

    const TextHandle = () => {
        if (HeadingUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: HeadingUpdate,
                id: TextId
            })
            setTextModalVisible(false);
            setHeadingUpdate('')
        }
    };

    const handleCancel = () => {
        setTextModalVisible(false);
    };

    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if(event.key === 'Enter'){
          console.log('Enter Clicked')
          a.concat('\n')
          setHeadingUpdate(a)
        }else{
          console.log(event.key)
        }
      }

    return (
        <div className='Commercial-Container'>
            <h2 className='Heading'>{GetData.section2heading1.content}
                <i onClick={() => ShowTextModal(GetData.section2heading1._id)} className="far fa-edit Edit-btn"></i>
            </h2>
            <p> {GetData.section2paragraph1.content}
                <i onClick={() => ShowTextModal(GetData.section2paragraph1._id)} className="far fa-edit Edit-btn"></i>
            </p>


            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '30%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e)=> OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
            </Modal>

        </div>
    )
}

export default TypeOfMoving
